jQuery(document).ready(function ($) {
	$('.read-more-link').on('click', function (e) {
		e.preventDefault();
		var $description = $(this).closest('.description');
		var $collapsed = $description.find('.collapsed');
		var $expanded = $description.find('.expanded');

		$expanded.addClass('open');

		// Calculate and set max-height dynamically based on the content height
		var expandedHeight = $expanded.prop('scrollHeight');
		$expanded.css('max-height', expandedHeight + 'px');

		// Hide the 'Read more' label when content is expanded
		$collapsed.find('.read-more').hide();
	});

	$('.read-less-link').on('click', function (e) {
		e.preventDefault();
		var $description = $(this).closest('.description');
		var $expanded = $description.find('.expanded');

		$expanded.removeClass('open').css('max-height', '');

		// Show the 'Read more' label when content is collapsed
		$description.find('.collapsed .read-more').show();
	});
});
